import { SearchOutlined } from '@ant-design/icons-vue'
import { ShareMembers } from './shareMembers'
import { getMembers } from '~/api'
import type { Member, ShareParams } from '~/api/interface'

export const Share = defineComponent({
  props: {
    params: {
      type: Object as PropType<ShareParams>,
      default: () => ({}),
    },
    height: {
      type: String,
      default: '180px',
    },
    trackParams: {
      type: Object,
    },
    showExtra: {
      type: Boolean,
      default: false,
    },
    linkUrl: {
      type: String,
      default: '',
    },
  },
  emits: ['success'],
  setup(props) {
    const { $t } = useNuxtApp()
    const search = ref('')
    const session = useSession()
    const list = ref<Member[]>([])
    const loading = ref(false)
    const getData = async () => {
      loading.value = true
      try {
        const res = await getMembers({
          ignore_kicked: true,
          many: 1,
          is_active_user: 2,
        })
        if (res.code !== 0) {
          return
        }
        loading.value = false
        list.value =
          res.data?.filter(
            (item) => Number(item.user_id) !== Number(session.value?.user_id)
          ) || []
      } catch (error) {
        console.error(error)

        loading.value = false
      }
    }
    const searchList = computed(() => {
      if (!search.value) {
        return list.value
      }
      return list.value.filter((item) => {
        return (
          item &&
          item?.account_name
            ?.toLocaleLowerCase()
            ?.includes(search.value?.toLocaleLowerCase())
        )
      })
    })
    getData()
    return () => [
      <div class="text-14 font-semibold mb-[5px]">
        {props.linkUrl ? '1.' : ''}
        {$t('fen-xiang-gei-nei-bu-cheng-yuan')}
      </div>,
      props.showExtra && (
        <div class="text-font-40 text-12 mb-[10px]" v-if={props.showExtra}>
          {$t(
            'fen-xiang-de-cheng-pian-zhi-zhi-chi-cha-kan-mei-you-bian-ji-quan-xian'
          )}
        </div>
      ),
      <a-input
        value={search.value}
        onUpdate:value={(v: string) => (search.value = v)}
        placeholder={$t('qing-shu-ru-sou-suo-guan-jian-zi')}
      >
        {{ suffix: () => <SearchOutlined /> }}
      </a-input>,
      <ShareMembers
        loading={loading.value}
        list={searchList.value}
        params={props.params}
        trackParams={props.trackParams}
        style={{ height: props.height }}
      />,
    ]
  },
})
